<style lang="scss" scoped>
.menu {
	&__icon {
		font-size: 30px;
		margin-right: 30px;
		opacity: 0.7;
	}
	&__box {
		margin-bottom: 20px;
		&:last-child {
			margin-bottom: 0;
		}
	}
	&__container {
		@include container;
	}
	&__panel {
		@include main-panel-padded;
	}
	&__link {
		@include flex;
		padding: 40px;
		cursor: pointer;
		&__description {
			color: lighten(black, 40);
		}
		&__header {
			margin: 0 0 10px 0;
			padding-bottom: 5px;
			&:after {
				content: "";
				width: 270px;
				height: 3px;
				margin-top: 10px;
				display: block;
				background: #1d6bf3;
				opacity: 0.4;
			}
		}
	}
}
</style>
<template lang="pug">
.menu
	app-header
			.menu__header(slot='header')
				h1 Match school data
	.menu__container
			.menu__panel
				el-card(shadow="hover", :body-style='{ padding:0 }').menu__box
					router-link(:to="{name:'matching.users'}" tag="div").menu__link
							div.menu__icon
								i.fe.fe-users
							div
								h3.menu__link__header Match users
								div.menu__link__description Match users from your MIS with existing users in your school's {{ providerFullName }} account.
				el-card(v-if="features.group" shadow="hover", :body-style='{ padding: 0}').menu__box
					el-alert(v-if="settings.group_create_mode === 'self'" type="warning" center show-icon :closable="false" title="Group creation is not enabled" :description="`To allow groups to be automatically created during a sync, see Settings > ${providerName} Groups`")
					router-link(:to="{name:'matching.groups'}" tag="div").menu__link
							div.menu__icon
								i.fe.fe-folder
							div
								h3.menu__link__header Match groups
								div.menu__link__description Match registration and year groups from your MIS with your school's {{ providerFullName }} account.
				el-card(v-if="features.classroom || providerCode === 'msft'" shadow="hover", :body-style='{ padding: 0}').menu__box
					el-alert(v-if="settings && settings.class_create_mode === 'self' && providerCode === 'gapps'" type="warning" center show-icon :closable="false" title="Class creation is not enabled" :description="`To allow classes to be automatically created during a sync, see Settings > ${providerName} Classroom`")
					router-link(:to="{name:'matching.classes'}" tag="div").menu__link
							div.menu__icon
								i.fe.fe-folder
							div
								h3.menu__link__header Match classes
								div.menu__link__description Match classes from your MIS with your school's {{ classroomName }}.
					router-link(:to="{name:'class.management'}" tag="div", v-if="providerCode === 'msft'").menu__link
							div.menu__icon
								i.fe.fe-folder-plus
							div
								h3.menu__link__header Advanced class management
								div.menu__link__description Manage {{ classroomName }} and match them with multiple classes from your MIS. 

</template>
<script>
import gql from "graphql-tag";
export default {
	data() {
		return {
			settings: {}
		}
	},

	mounted() {
		if (!this.features.group && !this.features.classroom) this.$router.push({ name: "matching.users" });
	},

	apollo: {
		settings: {
			query: gql`
				{
					Settings {
						id
						group_create_mode
						class_create_mode
					}
				}
			`,
			fetchPolicy: "cache-and-network",
			update(r) {
				return _.cloneDeep(r.Settings);
			}
		},
	}
};
</script>
